export const hackathonData = [
  {
    title: "The Power of Web3 Hackathons",
    content: [
      {
        type: "heading",
        text: "Innovation Through Competition"
      },
      {
        type: "paragraph",
        text: "Web3 hackathons are intensive events where developers, designers, and entrepreneurs come together to build innovative blockchain-based solutions. These events have become crucial catalysts for Web3 innovation and adoption worldwide."
      }
    ]
  },
  {
    title: "Global Web3 Hackathons",
    content: [
      {
        type: "heading",
        text: "Major International Events"
      },
      {
        type: "list",
        items: [
          "ETHGlobal: Premier Ethereum hackathon series",
          "Solana Hackathons: Building on Solana blockchain",
          "Polygon Hackathons: Layer 2 scaling solutions",
          "Chainlink Hackathons: Oracle and smart contract development"
        ]
      }
    ]
  },
  {
    title: "Malaysian Web3 Organizations",
    content: [
      {
        type: "heading",
        text: "Local Blockchain Initiatives"
      },
      {
        type: "list",
        items: [
          "MDEC (Malaysia Digital Economy Corporation)",
          "MaGIC (Malaysian Global Innovation & Creativity Centre)",
          "Blockchain Association of Malaysia",
          "Malaysian Fintech Association"
        ]
      }
    ]
  },
  {
    title: "Malaysian University Blockchain Clubs",
    content: [
      {
        type: "heading",
        text: "Student-Led Innovation"
      },
      {
        type: "list",
        items: [
          "APUBCC (Asia Pacific University Blockchain & Cryptocurrency Club)",
          "Monash University Blockchain Society",
          "Sunway University Fintech Club",
          "TAR UC Technology Innovation Club",
          "UM (University of Malaya) Blockchain Society",
          "UTM Blockchain Research Group"
        ]
      }
    ]
  },
  {
    title: "Benefits of Participation",
    content: [
      {
        type: "heading",
        text: "Why Join Hackathons?"
      },
      {
        type: "list",
        items: [
          "Skill Development: Learn new technologies rapidly",
          "Networking: Meet industry professionals and peers",
          "Career Opportunities: Job offers and startup connections",
          "Prize Money: Significant rewards for winning teams",
          "Portfolio Building: Showcase your development skills"
        ]
      }
    ]
  }
];
